import { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { setFilters } from '@/store/slices/speakersSlice'
import { Tab } from '@headlessui/react'
import { BsArrowRight } from 'react-icons/bs'
import Markdown from '@/components/common/Markdown'
import Button from '@/components/common/Button'
import Carousel from '@/components/common/Carousel'

const ExploreSpeakers = ({ featuredSpeakers = null, trendingSpeakers = null, handleClick }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const sliderRef = useRef(null)

  const menu = [
    { title: 'Featured', path: '#' },
    { title: 'Trending', path: '#' },
  ]

  const handleRedirect = (slug) => {
    if (typeof window !== 'undefined') {
      dispatch(
        setFilters({
          categories: null,
          searchQuery: '',
          types: null,
          profileCategory: null,
          relatedSpeakers: null,
          sortOrder: null,
        })
      )
      const url = `/speaker/${slug}`
      router.push(url)
    }
  }

  const tabPanel = document.querySelector('.tabPanel')

  const isInViewport = (element) => {
    const rect = element?.getBoundingClientRect()
    return (
      rect?.top >= 0 &&
      rect?.left >= 0 &&
      rect?.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect?.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  useEffect(() => {
    if (navigator.userAgent.indexOf('Mac') != -1) {
      ;(document.querySelector('.featuredClass').style.marginTop = '-5px'),
        (document.querySelector('.trendingClass').style.marginTop = '-5px')
    }
  }, [])

  useEffect(
    () =>
      document.addEventListener('scroll', () => {
        const isView = isInViewport(tabPanel)
        if (isView) {
          const previousBtn = document.getElementById('previous')
          const nextBtn = document.getElementById('next')
          document.addEventListener('keydown', ({ key }) => {
            key === 'ArrowLeft' && previousBtn?.click()
            key === 'ArrowRight' && nextBtn?.click()
          })
        }
      }),
    [tabPanel]
  )

  return (
    <div className="mb-20 minXs:mt-[84px] mt-[50px]">
      <div className="w-full sm:px-0">
        <Tab.Group>
          <div className="flex flex-wrap md:flex-row flex-col md:items-center md:space-x-8 md:text-sm md:font-thin">
            <h1 className="px-2 xs:px-0 leading-10 pt-[10px] tagline-font tracking-wide lg:text-[32px] text-2xl maxSm:text-xl md:pr-2 uppercase small:px-4">
              Browse UTA Speakers
            </h1>
            <span className="px-2 xs:px-0 md:mt-0 mt-3 small:px-4">
              <Tab.List>
                {menu
                  ?.filter((n) => JSON.stringify(n) !== '{}')
                  ?.map((item, i) => (
                    <Tab key={i} className="pr-2 focus:outline-none lg:pl-2">
                      {({ selected }) => (
                        <a
                          className={
                            selected
                              ? 'bg-opacity-50 bg-custom-gray-80 inline-block w-24 h-10 focus:outline-none flex justify-center items-center'
                              : 'inline-block w-24 h-10 focus:outline-none flex justify-center items-center'
                          }
                        >
                          <div
                            className={classNames(
                              item?.title == 'Featured' ? 'featuredClass' : 'trendingClass',
                              'pt-1 text-base font-normal text-center text-white md:flex-row md:items-center'
                            )}
                          >
                            {item.title || ''}
                          </div>
                        </a>
                      )}
                    </Tab>
                  ))}
              </Tab.List>
            </span>
          </div>
          <Tab.Panels className="pt-6 outline-none">
            <Tab.Panel ref={sliderRef} className="tabPanel">
              {!featuredSpeakers ? (
                <div className="flex flex-wrap shadow">
                  {[...Array(4)].map((item, index) => (
                    <div className="flex flex-col flex-wrap p-4 animate-pulse md:w-1/4" key={index}>
                      <div className=" bg-custom-gray-80 late-200 h-72"></div>
                      <div className="flex-1 py-1 space-y-2">
                        <div className="w-20 h-2 mt-2 bg-custom-gray-80"></div>
                        <div className="h-2 bg-custom-gray-80"></div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <Carousel data={featuredSpeakers} handleClick={(e) => handleRedirect(e)} />
              )}
            </Tab.Panel>
            {/* Trending  Speakers Tab */}
            <Tab.Panel ref={sliderRef} className="tabPanel">
              {!trendingSpeakers ? (
                <div className="flex flex-wrap shadow">
                  {[...Array(4)].map((item, index) => (
                    <div className="flex flex-col flex-wrap p-4 animate-pulse md:w-1/4" key={index}>
                      <div className=" bg-custom-gray-80 late-200 h-72"></div>
                      <div className="flex-1 py-1 space-y-2">
                        <div className="w-20 h-2 mt-2 bg-custom-gray-80"></div>
                        <div className="h-2 bg-custom-gray-80"></div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <Carousel data={trendingSpeakers} handleClick={(e) => handleRedirect(e)} />
              )}
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
        <div className="flex items-center justify-center w-full mt-8">
          <a
            className="flex items-center justify-center button-style md:w-72 button-hover group"
            onClick={handleClick}
          >
            <Button className="pr-3.5" label="View All UTA Speakers" />
            <BsArrowRight className="w-5 h-5 ml-2 text-white group-hover:text-black " />
          </a>
        </div>
      </div>
    </div>
  )
}

export default ExploreSpeakers
